import { render, staticRenderFns } from "./NotificationPayerDetails.vue?vue&type=template&id=bc4302a2&scoped=true"
import script from "./NotificationPayerDetails.vue?vue&type=script&lang=js"
export * from "./NotificationPayerDetails.vue?vue&type=script&lang=js"
import style0 from "./NotificationPayerDetails.vue?vue&type=style&index=0&id=bc4302a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4302a2",
  null
  
)

export default component.exports